export function normalizeFeatureName<FeatureFlagName extends string>(flagName: FeatureFlagName) {
    return flagName.toLocaleLowerCase().trim() as Lowercase<FeatureFlagName>;
}
